export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const IMAGE_PATH = "https://career.uwed.uz/api/storage/files/";
